import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import WidgetBox, { Props as WidgetBoxProps } from '../_partials/WidgetBox';
import SubscriptionCenter from './SubscriptionCenter';
import s from './SubscriptionCenterBox.scss';

const SubscriptionCenterBox: React.FC<WidgetBoxProps> = ({
  moduleId,
  widgetMoveUp,
  widgetMoveDown,
  widgetRemove,
  isCurrentUserProfileOwner,
  profileOwnerUser,
  section,
  zone,
  className,
  ...props
}) => {
  const { t } = useTranslation();
  return (
    <WidgetBox
      className={s['root']}
      section={section}
      zone={zone}
      header={t(`widgets.subscription_center.header`)}
      hasMore={false}
      moduleId={moduleId}
      widgetMoveUp={widgetMoveUp}
      widgetMoveDown={widgetMoveDown}
      widgetRemove={widgetRemove}
      isEmpty={false}
    >
      <SubscriptionCenter
        moduleId={moduleId}
        className={c(s['subscription-center'], className)}
        {...props}
      />
    </WidgetBox>
  );
};

SubscriptionCenterBox.displayName = 'SubscriptionCenterBox';
export default SubscriptionCenterBox;
